import { useEffect, useState } from "react";

function useTabVisibility(): boolean {
  const [isVisible, setIsVisible] = useState<boolean>(true);

  const handleVisibilityChange = () => {
    setIsVisible(!document.hidden);
  };

  useEffect(() => {
    // Add a listener for the visibilitychange event
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Clean up the listener when the component unmounts
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return isVisible;
}

export default useTabVisibility;
